// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-social-link[data-v-9f797a9a]{font-size:2.6rem;color:#fff}.footer-social-link[data-v-9f797a9a]:hover{color:#c2c2c2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
